export var TwoFactorMethod;
(function (TwoFactorMethod) {
    TwoFactorMethod["Sms"] = "Sms";
    TwoFactorMethod["Email"] = "Email";
})(TwoFactorMethod || (TwoFactorMethod = {}));
//# sourceMappingURL=session.js.map